import React, { useEffect, useState } from 'react';
import { obtenerMovimientos } from '../services/movimientosService';
import { mensajeAmigable } from '../utils/errores';
import { formatoCantidad } from '../utils/unidades';

// Cómo se muestra cada tipo de movimiento de inventario.
const TIPOS = {
  creacion: { icono: '🆕', texto: 'Producto creado', color: 'var(--k-verde)' },
  ajuste: { icono: '⚙️', texto: 'Ajuste de stock', color: '#2563EB' },
  venta: { icono: '🛒', texto: 'Venta', color: '#DB2777' },
  devolucion: { icono: '↩️', texto: 'Devolución (venta eliminada)', color: '#D97706' },
  eliminacion: { icono: '🗑️', texto: 'Producto eliminado', color: '#DC2626' },
};

// Historial de movimientos de UN producto (entradas y salidas de stock).
export default function HistorialProductoModal({ producto, onCerrar }) {
  const [movs, setMovs] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    obtenerMovimientos({ productoId: producto.id, limite: 100 })
      .then(setMovs)
      .catch((e) => setError(mensajeAmigable(e)));
  }, [producto.id]);

  const fechaHora = (iso) => new Date(iso).toLocaleString('es-HN', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', width: '520px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box', padding: '22px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
          <div>
            <h3 style={{ margin: 0, color: 'var(--color-primario,#DB2777)' }}>📜 Historial del producto</h3>
            <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#6B7280' }}>
              {producto.nombre} · {producto.codigo}
            </p>
          </div>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer' }}>✕</button>
        </div>

        <p style={{ margin: '10px 0 14px', fontSize: '13px', color: '#374151' }}>
          Stock actual: <strong>{formatoCantidad(producto.stock, producto)}</strong>
        </p>

        {error && <p style={{ color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
        {!movs && !error && <p style={{ textAlign: 'center', color: '#6B7280', padding: '24px' }}>⏳ Cargando historial...</p>}
        {movs && movs.length === 0 && (
          <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '24px' }}>
            Este producto todavía no tiene movimientos registrados.
          </p>
        )}

        {movs && movs.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {movs.map((m) => {
              const t = TIPOS[m.tipo] || { icono: '•', texto: m.tipo, color: '#6B7280' };
              const entra = Number(m.cantidad) >= 0;
              return (
                <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', border: '1px solid #F3F4F6', borderRadius: '10px', backgroundColor: '#FAFAFA' }}>
                  <span style={{ fontSize: '20px' }}>{t.icono}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ margin: 0, fontWeight: 600, color: t.color, fontSize: '14px' }}>{t.texto}</p>
                    <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
                      {fechaHora(m.creado_en)}
                      {m.motivo ? ` · ${m.motivo}` : ''}
                    </p>
                  </div>
                  <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <p style={{ margin: 0, fontWeight: 'bold', fontSize: '14px', color: entra ? 'var(--k-verde)' : '#DC2626' }}>
                      {entra ? '+' : ''}{m.cantidad}
                    </p>
                    {(m.stock_anterior != null && m.stock_nuevo != null) && (
                      <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#9CA3AF' }}>
                        {m.stock_anterior} → {m.stock_nuevo}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
